(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editable-review-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-carousel')) {
    class ReviewCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-review-viewport]');
        this.track = this.querySelector('.editable-review-carousel__track');
        this.cards = Array.from(this.querySelectorAll('.editable-review-carousel__card'));
        this.previousButton = this.querySelector('[data-review-prev]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        if (!this.viewport) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
        });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        this.viewport.scrollBy({ left: direction * this.pageWidth(), behavior: 'smooth' });
      }

      pageWidth() {
        const gap = this.track ? parseFloat(getComputedStyle(this.track).columnGap) || 0 : 0;
        return this.viewport.clientWidth + gap;
      }

      queueUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          this.update();
        });
      }

      update() {
        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const visibleCards = window.matchMedia('(min-width: 750px)').matches ? 4 : 2;
        const pageCount = Math.max(1, Math.ceil(this.cards.length / visibleCards));
        const currentPage = maxScroll === 0 ? 1 : Math.min(pageCount, Math.round(this.viewport.scrollLeft / this.pageWidth()) + 1);
        if (this.previousButton) this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.viewport.scrollLeft >= maxScroll - 2;
        if (this.status) this.status.textContent = `${currentPage} / ${pageCount}`;
      }
    }

    customElements.define('review-carousel', ReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
